import { API_ENDPOINT } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const LANG_ENDPONT = `${API_ENDPOINT}/lang`;

const langManagerApi = {
   gets: (params) => {
      return axiosClient.get(LANG_ENDPONT, { params });
   },

   get: (id) => {
      return axiosClient.get(`${LANG_ENDPONT}/${id}`);
   },

   post: (body) => {
      return axiosClient.post(LANG_ENDPONT, body);
   },

   put: (id, body) => {
      return axiosClient.put(`${LANG_ENDPONT}/${id}`, body);
   },

   delete: (id) => {
      return axiosClient.delete(`${LANG_ENDPONT}/${id}`);
   },
};

export default langManagerApi;
